import React, { useEffect, useState } from "react";
import ImageCard from "./ImageCard";
import PhotoGalleryModal from "./PhotoGalleryModal";

const PhotoGallery = () => {
  const [imagesData, setImagesData] = useState([]);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    fetch(`PhotoGalleryData.json`)
      .then((res) => res.json())
      .then((data) => setImagesData(data));
  }, []);
  console.log(imagesData);
  return (
    <div className="mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 ">
      <div className="font-serif items-center text-center mt-8 mb-5">
        <h1 className="text-3xl font-bold  text-black">My Photo Gallery</h1>
        <p className="text-xl">
          Morbi leo risus, porta ac consectetur ac, vestibulum at eros. <br />{" "}
          Etiam porta sem malesuada magna mollis euismod. Maecenas sed diam eget
          risus varius blandit sit.
        </p>
      </div>
      <div className="grid gap-5 mt-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {imagesData.map((imageData, i) => (
          <ImageCard key={i} setModal={setModal} imageData={imageData} />
        ))}
      </div>
      {modal && <PhotoGalleryModal modal={modal} />}
    </div>
  );
};

export default PhotoGallery;
